<template>
    <div class="main-content join-company">
        <h2>请在下方输入公司邀请码：</h2>
        <div class="b-b m-b-md"></div>
        <div class="row">
            <div class="input-item">
                <div class="col-sm-4">
                    <input type="text" class="input" placeholder="公司邀请码" required="required" v-model.trim="invite_code" autocomplete="off">
                    <span class="input-tips">{{error.invite_code}}</span>
                </div>
                <div class="col-sm-4 n-p-l">
                    <button type="button" class="btn btn-md btn-success p-l-r-lg" :disabled="!join_active" @click="joinCompany()">加入公司</button>
                </div>
            </div>
            <div v-if="company._id">
                <div class="input-item">
                    <div class="col-sm-6">
                        <div class="company-info">
                            公司名称:&nbsp;{{company.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { deepCopy } from '../../plugins/utils'
import User from '../../resource/user'
import Company from '../../resource/company'
export default {
    data: function () {
        return {
            invite_code: '',
            join_active: false,
            company: {},
            error: {
                invite_code: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            'user': 'loginUser'
        })
    },
    created: function () {
        const that = this
        document.title = `成为HR-个人中心|${that.global.name}`
        if (that.user.category === 2) {
            that.$router.replace('/company')
        } else if (that.user.role === 2) {
            that.$router.replace('/user')
        }
    },
    watch: {
        'invite_code': function () {
            const that = this
            that.validateCode()
        }
    },
    methods: {
        validateCode: function () {
            const that = this
            if (that.global.regex.invite_code.test(that.invite_code)) { // 符合要求
                that.error.invite_code = ''
                Company.getByCode({ 'code': that.invite_code }, {}).then(res => {
                    let data = res.body;
                    if (data.code === 3) {
                        that.error.invite_code = '请输入正确的邀请码'
                    } else if (data.code === 2) {
                        that.error.invite_code = '服务器繁忙，请稍后再重试(╯﹏╰）!!!'
                        alert("服务器繁忙，请稍后再重试(╯﹏╰）!!!\n有人要扣钱了(>﹏<)！！！")
                    } else if (data.code === 0) {
                        that.error.invite_code = ''
                        that.company = data.result
                        that.join_active = true
                    } else {
                        alert(data.msg)
                    }
                });
            } else {
                that.error.invite_code = '请输入正确的邀请码'
            }
        },
        joinCompany: function () {
            const that = this
            if (!that.user.realname || !that.user.phone) {
                alert('您尚未填写真实姓名或者没有验证手机\n请完善信息后再次加入公司')
            } else {
                if (confirm(`您确定要加入“${that.company.name}”公司，成为该公司的HR么？`)) {
                    that.join_active = false
                    Company.join({}, { code: that.invite_code }).then(res => {
                        let data = res.body
                        if (data.code == 0) {
                            let userInfo = deepCopy(that.user)
                            userInfo.category = 1
                            userInfo.role = 2
                            userInfo.company = that.company
                            that.$store.dispatch('loadSession', userInfo)
                            alert('您已加入该公司')
                            that.$router.replace('/company')
                        } else {
                            alert(data.msg)
                        }
                    }, res => { })
                }
            }
            // 
        }
    }
}
</script>
<style lang="less" scoped>
.join-company {
    .company-info {
        background-color: #eee;
        padding: 15px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// join-company.vue?cee7f75a